// extracted by mini-css-extract-plugin
export default {"topTip":"topTip__88eed58e","left":"left__85c1f904","closeBtn":"closeBtn__de135fcf","closeIcon":"closeIcon__69050ba9","centerImg":"centerImg__1770c8c3"};